import { ActionType } from './action-type.enum';
import { Action } from './action.type';
import { State } from './state';

const reducer = (state: State, { type, payload }: Action): State => {
  switch (type) {
    case ActionType.POP_UP_OPEN:
      return {
        ...state,
        isPopUpOpened: true,
      };
    case ActionType.POP_UP_CLOSE:
      return {
        ...state,
        isPopUpOpened: false,
      };
    case ActionType.SET_POP_UP_HEADER:
      return {
        ...state,
        popUpHeader: payload.popUpHeader,
      };
    case ActionType.SET_POP_UP_CONTENT:
      return {
        ...state,
        PopUpContent: payload.PopUpContent as () => React.JSX.Element,
      };
    case ActionType.SET_POP_UP_FOOTER:
      return {
        ...state,
        PopUpFooter: payload.PopUpFooter as () => React.JSX.Element,
      };
    case ActionType.SET_DOCTOR_APPOINTMENT:
      return {
        ...state,
        doctorAppointment: payload.doctorAppointment,
      };
    case ActionType.SET_VYDURA_REMINDER:
      return {
        ...state,
        vyduraReminder: payload.vyduraReminder,
      };
    case ActionType.SET_MIGRAINE_ATTACK:
      return {
        ...state,
        migraineAttacks: payload.migraineAttacks ?? [],
      };
    case ActionType.SET_VYDURA_SCHEDULE:
      return {
        ...state,
        vyduraSchedule: payload.vyduraSchedule,
      };
    default:
      return state;
  }
};

export default reducer;
